import React from 'react'
import styles from './StatFilterButton.module.scss'

interface StatFilterButtonProps {
  children: React.ReactNode
  active: boolean
  onClick: () => void
  className?: never
}

export const StatFilterButton: React.FC<StatFilterButtonProps> = ({
  children, active, onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={[styles.button, active ? styles.active : ''].filter(Boolean).join(' ')}
  >
    {children}
  </button>
)
